export const UPDATE_ERROR = 'UPDATE_ERROR'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const DELETE_USER = 'DELETE_USER'
export const CLEAR_NOTIF_STATE = 'CLEAR_NOTIF_STATE'
